import React, { useState } from "react";
import {
  Box,
  Flex,
  Icon,
  Tab,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
  Text,
  Button,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import { Users, CarTaxiFront, HandCoins, Cog, FileClock, HelpingHand, ChartBar } from "lucide-react";
import BackgroundImage from "../../../assets/img/longarrow.jpg";
import DriverPartners from "../DriverPartnersManagement";
import CommissionRuleManagement from "../CommissionRuleManagement";
import CommissionPayoutManagement from "../DriverPartnerCommissionPayoutManagement";
import PayoutHistory from "../DriverPartnerCommissionPayoutManagement/PayoutHistory";
import DriverPartnerSupportTab from "../DriverPartnerSupport";
import DriverPartnerAnalytics from "../DriverPartnerAnalytics";

// Custom Tab Component
const CustomTab = ({ icon, label }) => (
  <Tab
    fontSize="sm"
    color="gray.500"
    _selected={{
      color: "white",
      bg: "transparent",
      backgroundImage: `url(${BackgroundImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  >
    <Icon as={icon} mr={2} />
    {label}
  </Tab>
);

const DriverPartnerOperations = () => {
  return (
    <Box w="100%" p={4} mt={"70px"} ml={"9px"}>

      <Tabs variant="enclosed">
        <TabList>
          <CustomTab icon={Users} label="Driver Partners" />
          <CustomTab icon={Cog} label="Commission Rule Manager" />
          <CustomTab icon={HandCoins} label="Pending Commission Payouts" />
          <CustomTab icon={FileClock} label="Payout History" />
          <CustomTab icon={HelpingHand} label="Partner Support" />
          <CustomTab icon={ChartBar} label="Analytics" />
        </TabList>

        <TabPanels>
          <TabPanel>
            <DriverPartners />
          </TabPanel>
          <TabPanel>
            <CommissionRuleManagement />
          </TabPanel>
           <TabPanel>
            <CommissionPayoutManagement />
          </TabPanel>
             <TabPanel>
            <PayoutHistory />
          </TabPanel>
            <TabPanel>
            <DriverPartnerSupportTab />
          </TabPanel>
            <TabPanel>
            <DriverPartnerAnalytics />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};


export default DriverPartnerOperations;
